import React, { useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import Layout from '../../components/Layout'
import { useLoad } from '../../hooks/request'
import { ANIMAL_LIST, ANIMAL_TYPE_LIST, ANIMAL_TYPE_DETAIL, ANIMAL_EXPORT_EXCEL, domain } from '../../urls'
import { useModal } from '../../hooks/modal'
import Card from '../../components/common/Card'
import Table from '../../components/common/Table'
import Button from '../../components/common/Button'
import AnimalItem from '../../components/animals/AnimalItem'
import AnimalCreate from '../../components/animals/AnimalCreate'

export default function Animals() {
    const { typeId } = useParams()
    const history = useHistory()
    const [page, setPage] = useState(1)
    const animals = useLoad({
        url: ANIMAL_LIST,
        params: {
            ...(typeId ? { animal_type: typeId } : {}),
            page
        }
    }, [typeId, page])
    const animalTypes = useLoad({ url: ANIMAL_TYPE_LIST })
    const currentType = useLoad({ url: typeId ? ANIMAL_TYPE_DETAIL.replace('{id}', typeId) : null }, [typeId])

    const [showCreateModal, hideCreateModal] = useModal(
        <AnimalCreate
            onSuccess={() => {
                hideCreateModal()
                animals.request()
            }}
            onCancel={() => hideCreateModal()}
            animalTypes={animalTypes.response ? animalTypes.response.results : []}
            initialTypeId={typeId}
        />,
    )

    const handleExportExcel = () => {
        if (!typeId) {
            alert('Илтимос, ҳайвон турини танланг')
            return
        }

        const exportUrl = `${domain}/api/v1/${ANIMAL_EXPORT_EXCEL}?animal_type=${typeId}`

        // Create a temporary link and trigger download
        const link = document.createElement('a')
        link.href = exportUrl
        link.setAttribute('download', '')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }

    return (
        <Layout className="has-background-light">
            {typeId && (
                <div style={{ marginBottom: '20px' }}>
                    <Button
                        onClick={() => history.push('/animals')}
                        text="Орқага"
                        icon="arrow-back-outline"
                        className="is-light"
                    />
                </div>
            )}

            <Card>
                <div className="columns">
                    <div className="is-size-4 column">
                        {typeId && currentType.response
                            ? `${currentType.response.name} - Ҳайвонлар рўйхати`
                            : 'Ҳайвонлар рўйхати'}
                    </div>

                    <div className="column is-narrow">
                        {typeId && (
                            <Button
                                onClick={handleExportExcel}
                                text="Excel юклаб олиш"
                                icon="download-outline"
                                className="is-pulled-right is-success is-outlined"
                                style={{ marginRight: '10px' }}
                            />
                        )}
                        <Button
                            onClick={showCreateModal}
                            text="Янги ҳайвон қўшиш"
                            icon="add-outline"
                            className="is-pulled-right is-link is-outlined"
                        />
                    </div>
                </div>

                <Table
                    loading={animals.loading}
                    items={animals.response ? animals.response.results : []}
                    columns={{
                        index: '№',
                        image: 'Расм',
                        identification: 'ID рақам',
                        gender: 'Жинси',
                        type: 'Тури',
                        birth_date: 'Туғилган сана',
                        status: 'Ҳолати',
                        buttons: ''
                    }}
                    totalCount={animals.response ? animals.response.count : 0}
                    pageSize={15}
                    activePage={page}
                    onPageChange={setPage}
                    renderItem={(item, index) => (
                        <AnimalItem
                            index={index}
                            item={item}
                            key={item.id}
                            onRefresh={animals.request}
                            animalTypes={animalTypes.response ? animalTypes.response.results : []}
                        />
                    )}
                />
            </Card>
        </Layout>
    )
}
